import React from "react";
import Visa from "../images/visa.png";
import Mastercard from "../images/mastercard.png";
import Discover from "../images/discover.png";
import Amex from "../images/amex.png";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import { CircularProgress } from "@material-ui/core";

export default function PaymentMethod(method, imgSize) {
  //console.log("PAY METHOD", method);
  switch (method.toLowerCase()) {
    case "visa":
      return <img src={Visa} height={imgSize ? imgSize : 30} alt="card type" />;
    case "disc":
      return (
        <img src={Discover} height={imgSize ? imgSize : 30} alt="card type" />
      );
    case "mast":
      return (
        <img src={Mastercard} height={imgSize ? imgSize : 30} alt="card type" />
      );
    case "amex":
      return <img src={Amex} height={imgSize ? imgSize : 30} alt="card type" />;
    case "ach":
      return (
        <AccountBalanceIcon style={{ fontSize: imgSize ? imgSize : 30 }} />
      );
    default:
      return null;
  }
}
